import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import api from '@utils/api';
const RegisteredInStoreCheckoutConfirm = (props) => {
    const { t } = useTranslation();
    const [clickedCta, setClickedCta] = useState(false);
    const sendEmail = () => {
        api.forgotPasswordSendMail(props.email);
        setClickedCta(true);
    };
    return (React.createElement("div", { className: "text-section" }, !clickedCta ? (React.createElement(React.Fragment, null,
        React.createElement("p", { className: "text-section__description" },
            React.createElement("span", { dangerouslySetInnerHTML: {
                    __html: t('orderconfirmation.thankyou.sendemail', { 0: props.email }),
                } })),
        React.createElement("div", { className: "text-section__description" },
            React.createElement("button", { className: " button button--secondary full", onClick: () => sendEmail() },
                React.createElement("span", null, t('login.registeredinstore.sendemail')))))) : (React.createElement(motion.div, { initial: { opacity: 0 }, animate: { opacity: 1 }, transition: { duration: 0.3 } },
        React.createElement("p", { className: "text-section__description" },
            React.createElement("span", { dangerouslySetInnerHTML: {
                    __html: t('orderconfirmation.thankyou.resendemailtext', { 0: props.email }),
                } })),
        React.createElement("div", { className: "text-section__description" },
            React.createElement("p", { className: "mb-12" }, t('orderconfirmation.thankyou.resendemail')),
            React.createElement("button", { className: "button button--secondary full", onClick: () => sendEmail() },
                React.createElement("span", null, t('login.registeredinstore.resendemail'))))))));
};
export default RegisteredInStoreCheckoutConfirm;
